export const LANGUAGE_LOADED = "@EE/LANGUAGE_LOADED";
